if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR');
  });
}

import '/src/css/site.css';

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import lightbox from 'alpine-tailwind-lightbox';
import collapse from '@alpinejs/collapse';

Alpine.plugin(focus);
Alpine.plugin(lightbox);
Alpine.plugin(collapse);
Alpine.start();

if (document.querySelector('.glide')) {
  import('@glidejs/glide').then(({ default: Glide }) => {
    const glide = new Glide('.glide', {
      type: 'carousel',
      autoplay: 3000
    }).mount();

    const el = document.querySelector('.glide');
    el.addEventListener('mouseenter', () => glide.pause());
    el.addEventListener('mouseleave', () => glide.play());
    el.addEventListener('focusin', () => glide.pause());
    el.addEventListener('focusout', () => glide.play());
  });
}

import Aos from 'aos';

window.applyTheme = function (theme) {
  const html = document.documentElement;

  if (theme === 'dark') {
    html.classList.add('dark');
  } else {
    html.classList.remove('dark');
  }

  localStorage.setItem('theme', theme);
};

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
const savedTheme = localStorage.getItem('theme');

function getInitialTheme() {
  if (savedTheme) {
    return savedTheme;
  }
  return prefersDark.matches ? 'dark' : 'light';
}

prefersDark.addEventListener('change', (e) => {
  if (!localStorage.getItem('theme')) {
    window.applyTheme(e.matches ? 'dark' : 'light');
  }
});

if (document.querySelector('[data-aos]')) {
  Aos.init({
    once: true
  });
}
